import { Component, OnInit } from '@angular/core';
import { TemplateDetails } from 'src/app/core/models/impact-assessment/template-details-model';
import { impactAssessmentTemplateDetails, selfTemplateDetails } from 'src/app/core/models/self-assessment/template';
import { UserProfile } from 'src/app/core/models/user';
import { ToastViewModel } from 'src/app/core/models/view-model';
import { SessionService } from 'src/app/core/services/auth/session.service';
import { GeneralDataService } from 'src/app/core/services/general/general-data.service';
import { ImpactService } from 'src/app/core/services/impact/impact.service';
import { UserManagementService } from 'src/app/core/services/user-management/user-management.service';
import { drop } from 'underscore';

@Component({
  selector: 'app-impact-assessment-settings',
  templateUrl: './impact-assessment-settings.component.html',
  styleUrls: ['./impact-assessment-settings.component.scss']
})
export class ImpactAssessmentSettingsComponent implements OnInit {

  impactAssessmentTemplateDD: ImpactAssessmentSettings[];
  impactAssessmentTemplateNo!: number;
  templateDetail: TemplateDetails;
  totalTemplate!: number;
  isToastShow = false;
  toastModel: ToastViewModel;
  selfTemplateDetails!: selfTemplateDetails;
  impactTemplateDetails!: impactAssessmentTemplateDetails;
  divisionId!: number;
  userAccessToken: UserProfile;

  constructor(private impactService: ImpactService, private _userService: UserManagementService, private generalService: GeneralDataService,private sessionService: SessionService) {
    this.impactAssessmentTemplateDD = [];
    this.selfAssessmentTemplateDD = [];
    this.templateDetail = new TemplateDetails();
    this.toastModel = new ToastViewModel();
    this.userAccessToken = new UserProfile();
  }

  async ngOnInit(): Promise<void> {
    this.userAccessToken = await this.sessionService.getLoginUserInfo().toPromise();
    this.divisionId = this.userAccessToken.lastUsedJurisdictionId;
    //this.divisionId = JSON.parse(this.fetchFromBrowser("selectedDivision") as string);
    // this.sessionService.getLoginUserInfo().subscribe((result: UserProfile) => {
    //   this.userAccessToken = result;
    // });
    
    this.loadTemplateNo(this.userAccessToken.lastUsedJurisdictionId);
    this.generalService.getDivisionSelected().subscribe(res => {
      this.impactAssessmentTemplateDD = [];
      this.selfAssessmentTemplateDD = [];
      this.templateDetail = new TemplateDetails();
      this.toastModel = new ToastViewModel();
      this.divisionId = res;
      this.loadTemplateNo(res);
    })
  }
  loadTemplateNo(divisionId: number) {
    this._userService.getTemplateDetails(divisionId).subscribe((result: TemplateDetails) => {
      this.templateDetail = result;
      this.impactAssessmentTemplateNo = this.templateDetail.currentTemplateNo;
      this.totalTemplate = this.templateDetail.totalTemplateNo;
      this.selfAssessmentTemplateNo = this.templateDetail.currentSelfTemplateNo;
      this.totalSelfTemplate = this.templateDetail.totalSelfTemplateNo;
      if (this.impactAssessmentTemplateNo != 0 && this.totalTemplate != 0) {
        for (let i = 0; i < this.totalTemplate; i++) {
          this.impactAssessmentTemplateDD.push({ id: i + 1, title: "Template No " + (i + 1) });
        }
      }
      if (this.totalSelfTemplate != 0) {
        for (let i = 0; i < this.totalSelfTemplate; i++) {
          this.selfAssessmentTemplateDD.push({ id: i + 1, title: "Template No " + (i + 1) });
        }
      }
    });
  }
  updateTemplateNo(templateNo: number) {
    this.impactTemplateDetails = new impactAssessmentTemplateDetails();
    this.impactTemplateDetails.templateNo = templateNo;
    this.impactTemplateDetails.jurisdictionId = this.divisionId;
    if (this.templateDetail.currentTemplateNo == templateNo) {
      this.alertMessage('warning', 'Please select different Template No.');
    }
    else {
      if (templateNo > 0) {
        this._userService.updateImpactTemplateNo(this.impactTemplateDetails).subscribe((result => {
          this.templateDetail.currentTemplateNo  = templateNo;
          this.alertMessage('success', 'Successfully updated Template No.');
        }));
      }
    }
  }
  alertMessage(type: string, message: string): void {
    if (type === 'success') {
      this.toastModel.Title = 'Success';
      this.toastModel.Type = 'success';
    } else {
      this.toastModel.Title = 'Warning';
      this.toastModel.Type = 'warning';
    }
    this.toastModel.Message = message;
    this.isToastShow = true;
    setTimeout(() => {
      this.isToastShow = false;
    }, 3000);
  }

  ///////////////////////////////self assessment Settings/////////////////////////
  selfAssessmentTemplateNo!: number;
  selfAssessmentTemplateDD: ImpactAssessmentSettings[];
  totalSelfTemplate!: number;

  updateSelfTemplateNo(templateNo: number) {
    this.selfTemplateDetails = new selfTemplateDetails();
    this.selfTemplateDetails.templateNo = templateNo;
    this.selfTemplateDetails.jurisdictionId = this.divisionId;
    if (this.templateDetail.currentSelfTemplateNo == templateNo) {
      this.alertMessage('warning', 'Please select different Template No.');
    }
    else {
      if (templateNo > 0) {
        this._userService.updateSelfTemplateNo(this.selfTemplateDetails).subscribe((result => {
          if(result.message=="successfull"){
            this.templateDetail.currentSelfTemplateNo = templateNo;
            this.generalService.SATemplateChanged(templateNo);
          }
          this.alertMessage('success', 'Successfully updated Template No.');
        }));
      }
    }
  }

  fetchFromBrowser(key: string): any {
    return localStorage.getItem(key);
  }
}
export interface ImpactAssessmentSettings {
  id: number;
  title: string;
}
